import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FaqSection = ({
  title,
  highlightedText,
  desc,
  faqData,
}) => {

  const [activeIndex, setActiveIndex] =
    useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(
      activeIndex === index ? null : index
    );
  };

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // FAQ CARD
  const faqVariant = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.08,
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <section className="faq-section container">

        {/* TOP */}

        <motion.div
          className="faq-top"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
        >

          <motion.h2
            className="section-heading"
            variants={fadeUp}
          >
            {title}
            <span> {highlightedText}</span>
          </motion.h2>

          <motion.div
            className="heading-line"
            initial={{
              width: 0,
              opacity: 0,
            }}
            whileInView={{
              width: "120px",
              opacity: 1,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
            }}
          />

          <motion.p
            className="section-text faq-desc"
            variants={fadeUp}
          >
            {desc}
          </motion.p>

        </motion.div>

        {/* FAQ GRID */}

        <motion.div
          className="faq-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.12,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.08,
              },
            },
          }}
        >

          {faqData.map((item, index) => (

            <motion.div
              className={`faq-item ${
                activeIndex === index
                  ? "active-faq"
                  : ""
              }`}
              key={index}
              custom={index}
              variants={faqVariant}
              whileHover={{
                y: -3,
              }}
              transition={{
                duration: 0.25,
              }}
            >

              {/* QUESTION */}

              <button
                className="faq-question"
                onClick={() =>
                  toggleFaq(index)
                }
              >

                <span>
                  {item.question}
                </span>

                <motion.div
                  className="faq-icon"
                  animate={{
                    rotate:
                      activeIndex === index
                        ? 180
                        : 0,
                  }}
                  transition={{
                    duration: 0.35,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                >
                  ⌄
                </motion.div>

              </button>

              {/* ANSWER */}

              <AnimatePresence initial={false}>

                {activeIndex === index && (

                  <motion.div
                    className="faq-answer show-answer"
                    initial={{
                      height: 0,
                      opacity: 0,
                    }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                    }}
                    transition={{
                      duration: 0.45,
                      ease: [0.22, 1, 0.36, 1],
                    }}
                  >

                    <motion.p
                      className="section-text"
                      initial={{
                        y: 10,
                        opacity: 0,
                      }}
                      animate={{
                        y: 0,
                        opacity: 1,
                      }}
                      exit={{
                        y: -5,
                        opacity: 0,
                      }}
                      transition={{
                        duration: 0.3,
                        delay: 0.05,
                      }}
                    >
                      {item.answer}
                    </motion.p>

                  </motion.div>

                )}

              </AnimatePresence>

            </motion.div>

          ))}

        </motion.div>

      </section>
    </>
  );
};

export default FaqSection;